"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PAGINATION: {
        PAGE: "page",
        PAGE_ITEMS: "page-items",
    },
};
//# sourceMappingURL=QueryParameter.js.map